import React from 'react';
import { LocationPageTemplate } from '../../components/LocationPageTemplate';
export function SunLakesPage() {
  return <LocationPageTemplate city="Sun Lakes" cityShort="Sun Lakes" slug="sun-lakes" data-id="element-1021" />;
}